<template>
  <forms-list-activity
      v-model="selectedUser"

      ref="users"
      :form-type="FORM_TYPE"
      :context="context"
      :details-config="detailsConfig"
      :propMultiSelect=true
      :details-temporary-list="temporaryList"
      :details-master-form-config="masterFormConfig"
      :details-master-id="masterId"
      :meta-status="metaStatus"
      :details-mode="mode"
      :calling-form-config="callingFormConfig"
      :recordsWithChosenFilters="recordsWithChosenFilters"
      :filter="filter"
      :show-details="hasRequiredPermission"
      :propSelectionSize.sync="selectionSize"
      :propShowMultiSelect.sync="showMultiSelect"
      @add="addUser"
      @delete="deleteUser"
      @details="editUser"
      @selected="getSelectedUser"
      :custom-add="true"
      :custom-delete="true"
      :custom-details="true"
  >
    <template slot="above-grid">
      <span v-if="isOpen && !isSelect && hasRequiredPermission" class="my-1">
        {{ $tr("subs.available.std", "Assigned Standard subscriptions: #{1} of #{2} available", assignedSubsStandard, availableSubsStandard) }}<br/>
        {{ $tr("subs.available.des", "Assigned Designer subscriptions: #{1} of #{2} available", assignedSubsDesigner, availableSubsDesigner) }}<br>
        <span></span>
<!--        <b-button type="link" @click="addMoreSubs">{{ $tr("subs.add-more", "Add more subscriptions") }}</b-button>-->
      </span>
    </template>


  </forms-list-activity>
</template>

<script>

import Activity from "@/activity/Activity";
import SignIn from "@/components/SignIn";
import ActivityManager from "@/activity/ActivityManager";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import DialogManager from "@/utils/DialogManager";
import PermissionsSet from "@/server/PermissionsSet";
import UserCannotBeDeletedException from "@/server/com/silkplm/rpc/exceptions/UserCannotBeDeletedException";
import LastOwnerCannotBeDeletedException from "@/server/com/silkplm/rpc/exceptions/LastOwnerCannotBeDeletedException";
import VBox from "@/components/VBox";
import TooManyUsersException from "@/server/com/silkplm/rpc/exceptions/TooManyUsersException";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import FormsLoader from "@/components/forms/FormsLoader";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import Perms from "@/server/Perms";
import EntitiesList from "@/components/forms/EntitiesList.vue";
import Rpc from "@/Rpc";
import {DELETE_RESTRICTED} from "@/components/forms/FormsActions";
import RoutingKeys from "@/server/RoutingKeys";
import {openAddSubscriptionPage} from "@/components/subscriptions/Subs";
import Popup from "@/components/dashboard/Popup.vue";
import Events from "@/utils/Events";
import Order from "@/server/com/silkplm/model/plm/Order";
import Group from "@/server/com/silkplm/model/users/Group";


const EditUsers = () => require("@/components/forms/customizations/plm/EditUsers");

const FORM_TYPE = ApplicationUser;

export default {
  name: "DashboardUsers",
  permission: () => FormsLoader.formPermission(FORM_TYPE),
  components: {Popup, EntitiesList, CloseButton, FooterButton, VBox, SignIn, DataGrid2, FooterNavbar, FormsListActivity},

  async mounted() {
    this.hasRequiredPermission = SessionManager.hasPermission(Perms.ORGANIZATION_SETTINGS);

    if(!this.isSelect && this.hasRequiredPermission) {
      let slotsInfo = await Rpc.Subscriptions.slotsInfo();
      this.availableSubsStandard = slotsInfo.availableStandard;
      this.assignedSubsStandard = slotsInfo.assignedStandard;
      this.availableSubsDesigner = slotsInfo.availableDesigner;
      this.assignedSubsDesigner = slotsInfo.assignedDesigner;

    }
    if(this.mode === "DELETE"){
      if(this.userId){
        this.selectedUser = await Rpc.Users.getSelectedUserInfo(this.userId);
        await this.deleteUser();
      }
    }

    window["users"] = this;
    /** @type {DataGrid2|Vue} */
    this.grid = this.$refs.users.$refs.entititesList.grid;
    this.$subscribe(RoutingKeys.RK_SUBSCRIPTIONS_CHANGE, async () => {
      this.$refs.users.$refs.entititesList.refresh().then();
      let slotsInfo = await Rpc.Subscriptions.slotsInfo();
      this.availableSubsStandard = slotsInfo.availableStandard;
      this.assignedSubsStandard = slotsInfo.assignedStandard;
      this.availableSubsDesigner = slotsInfo.availableDesigner;
      this.assignedSubsDesigner = slotsInfo.assignedDesigner;
    });
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return $tr('users','Users');
    },

    getSelectedUser(user) {
      this.selectedUser = user;
    },

    addMoreSubs(){
      openAddSubscriptionPage();
    },
    async addUser() {
      try {
        await Rpc.Users.checkLimitUsersInOrganization();
        let result = await (await ActivityManager.showActivity(EditUsers, {
          mode: "NEW"
        })).getResult();
        if (result != null) {
          this.lists.push(result);
          this.grid.focusOnRow(result);
          this.$refs.users.$refs.entititesList.refresh().then();
        }
          let slotsInfo = await Rpc.Subscriptions.slotsInfo();
          this.availableSubsStandard = slotsInfo.availableStandard;
          this.assignedSubsStandard = slotsInfo.assignedStandard;
          this.availableSubsDesigner = slotsInfo.availableDesigner;
          this.assignedSubsDesigner = slotsInfo.assignedDesigner;
      } catch (e) {
        if (e instanceof TooManyUsersException) {
          if (e.msg === "Free plan") {
            EventBus.$emit(Events.showBuyPlanPopup, {popupStyle: 'upgrade', popupCanClose: true});
          } else if(e.msg === "No free subscriptions"){
            EventBus.$emit(Events.showBuyPlanPopup, {popupStyle: 'add-more', popupCanClose: true});
          } else {
            await DialogManager.info($tr('dashboard.to.much.users', 'Too much number of users in organization.'),
                $tr("dashboard.users.limits", "The organization's user limit must be equal to or less than ") +
                await Rpc.Users.getLimitOfUsersInOrganization());
          }
        }
      }
    },

    async deleteUser() {
      this.selectedUserId = this.selectedUser[0]['id'];
      this.selectedUserIndex = this.selectedIndex;
      let canDeleteWithInfo = await Rpc.Forms.canDeleteEntity(ApplicationUser.getRemoteClass(), this.selectedUserId);
      if (canDeleteWithInfo.canDelete === DELETE_RESTRICTED) {
        let message = $tr('dashboard.users.with.mail','There are other records related to User with email')
            + this.selectedUser[0].email + $tr("dashboard.cant.delete",", you can't delete this user.")
        DialogManager.info($tr('deleteForbidden','Delete forbidden'), message).then();
        return;
      }
      if (await DialogManager.yesNo($tr('dashboard.delete','Deleting user'),
          $tr('dashboard.sure.delete','Are you sure you want to delete this user?'))) {
        await this.deleteUserOkSubmit();
      }
    },


    async editUser() {
      this.selectedUserId = this.selectedUser[0]['id'];
      let idx = this.selectedIndex;
      if (this.selectedUserId) {
        let result = await (await ActivityManager.showActivity(EditUsers, {
          mode: "EDIT_AS_ADMIN",
          userId: this.selectedUserId,
          readOnlyInputs: true
        })).getResult();
        if (result != null) {
          this.lists[idx] = result;
          this.grid.refreshIndex(idx);
        }
        this.grid.highlightIndex(idx);
      }
    },

    async deleteUserOkSubmit() {
      if (this.selectedUserId) {
        try {
          await Rpc.Users.deleteUser(this.selectedUserId);
          this.lists.splice(this.selectedUserIndex, 1);
        } catch (e) {
          if (e instanceof UserCannotBeDeletedException) {
            await DialogManager.info("", $tr('dashboard.cennot.removed.yourself','You cannot remove yourself.'));
          }
          if (e instanceof LastOwnerCannotBeDeletedException) {
            await DialogManager.info("", $tr('dashboard.cannot.removed.last','You cannot remove the last owner.'));
          }
        }
      }
    },

  },

  props: {
    userId: {type: String, default: ""},
    mode:   {type: String, default: ""},
    context: {default: null},
    recordsWithChosenFilters: {default: null},
    hasWriteAccessToMaster: {default: false},
    detailsConfig: {default: null},
    masterId: {default: null},
    temporaryList: {default: null},
    masterFormConfig: {default: null},
    metaStatus: {default: null},
    callingFormConfig: {default:null},
    filter: {default: null},
    selectionSize: 0,
    showMultiSelect: false,
  },
  watch: {
    selectionSize: function (val) {
      this.$emit("update:selectionSize", this.selectionSize);
    },
    showMultiSelect: function (val) {
      this.$emit("update:showMultiSelect", this.showMultiSelect);
    },
  },
  data: function () { return {
    /** @type{ApplicationUser[]} */
    lists: [],
    fields: [
      {name: 'Login', prop: 'login', sortable: true, size: 150},
      {name: 'First Name', prop: 'firstName', sortable: true, size: 150},
      {name: 'Last Name', prop: 'lastName', sortable: true, size: 150},
      {name: 'Email', prop: 'email', sortable: true, size: 200},
      {name: 'Phone', prop: 'phone', size: 150 }
    ],
    isOpen: SessionManager.isOpen(),
    isSelect: this.context?.mode === 'select',
    assignedSubsDesigner: "-",
    availableSubsDesigner: "-",

    assignedSubsStandard: "-",
    availableSubsStandard: "-",

    selectedUser: null,
    selectedUserId: null,
    selectedIndex: null,
    selectedUserIndex: null,
    permissions: new PermissionsSet(),
    FORM_TYPE,
    formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
    hasRequiredPermission: false,
  }},

}
</script>
